<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout v-else wrap justify-start>
      <v-flex xs12 text-left>
        <span style="color: #000; font-size: 20px; font-family: poppinsbold"
          >Promoted Product List</span
        >
      </v-flex>
      <v-flex xs12 v-if="category && filterMain">
        <v-layout wrap justify-start v-if="category.length > 0">
          <v-flex xs12 sm6 md4 pa-5>
            <v-autocomplete
              outlined
              dense
              color="#8d8d8d"
              placeholder="Shop Name"
              v-model="sellerId"
              :items="sellerList"
              item-text="sellerid.shopName"
              item-value="_id"
              item-color="#FF1313"
              hide-details
              clearable
              class="text-left"
              label="Shop Name"
            >
            </v-autocomplete>
          </v-flex>
          
          <v-flex xs12 sm6 md4 pa-5>
            <v-autocomplete
              outlined
              dense
              color="#8d8d8d"
              placeholder="Category"
              v-model="filterSub"
              :items="subcategory"
              item-text="name"
              item-value="_id"
              item-color="#FF1313"
              hide-details
              clearable
              class="text-left"
              label="Category"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6 md2 pa-5>
            <v-autocomplete
              outlined
              dense
              color="#8d8d8d"
              placeholder="Product Type"
              v-model="productType"
              :items="productTypes"
              item-text="name"
              item-value="value"
              item-color="#FF1313"
              hide-details
              clearable
              class="text-left"
              label="Product Type"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6 md2 pa-5>
            <v-select
              v-model="productStatus"
              :items="productStatusList"
              item-text="name"
              item-value="value"
              item-color="#8d8d8d"
              color="#8d8d8d"
              outlined
              dense
              label="Status"
            >
            </v-select>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12>
        <v-layout wrap>
          <v-flex v-if="products.length > 0" xs12 text-left>
            <ProductList
              :productData="products"
              :filter="filterMain"
              :pages="pages"
              :pageFilters="pageFilters2"
              :prevRoute="prevRoute"
              :currentPage="currentPage"
              @stepper="winStepper"
            />
          </v-flex>
          <v-flex v-else xs12 text-left pa-4>
            <br />
            <span class="textField2"> No Products Found!!! </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import ProductList from "./productData";
export default {
  components: {
    ProductList,
  },
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      ServerError: false,
      timeout: 5000,
      msg: null,
      products: [],
      disabled: false,
      fromDate: new Date(),
      toDate: new Date(),
      menu1: false,
      menu2: false,
      currentPage: 1,
      pages: 0,
      date: new Date(),
      tabValue: 0,
      filterMain: null,
      filterSub: null,
      category: [],
      sellerId: null,
      subcategory: [],
      sellerList: [],
      productTypes: [
        { name: "Vegetarian", value: "Vegetarian" },
        { name: "Non-vegetarian", value: "Non-vegetarian" },
        { name: "Eggetarian", value: "Eggetarian" },
      ],
      productType: null,
      productStatusList: [
        { name: "Active", value: "Active" },
        { name: "Inactive", value: "Inactive" },
        { name: "All", value: null },
      ],
      prevRoute: localStorage.getItem("LS_ROUTE_KEY"),
      productStatus: null,
    };
  },
  computed: {
    pageFilters1() {
      if (this.$store.state.productPageFilters) {
        return this.$store.state.productPageFilters;
      } else {
        return {};
      }
      // {
      //   type: this.$route.name,
      //   currentPage: this.currentPage,
      //   shop: this.sellerId,
      //   mainCategory: this.filterMain,
      //   category: this.filterSub,
      //   productType: this.productType,
      //   status: this.productStatus,
      // };
    },
    pageFilters2() {
      return {
        type: this.$route.name,
        currentPage: this.currentPage,
        shop: this.sellerId,
        mainCategory: this.filterMain,
        category: this.filterSub,
        productType: this.productType,
        status: this.productStatus,
      };
    },
  },
  beforeMount() {
    this.getMaincat();
    if (this.filterMain) {
      this.getSubcat();
    }
    this.getsellerList();
    if (this.prevRoute == "/ProductInfo" || this.prevRoute == "/editProduct") {
      this.sellerId = this.pageFilters1.shop;
      // this.filterMain=this.pageFilters1.mainCategory
      this.filterSub = this.pageFilters1.category;
      // this.productStatus=this.pageFilters1.status
      this.productType = this.pageFilters1.productType;
      this.currentPage = this.pageFilters1.currentPage;
      console.log(this.pageFilters1.currentPage);
    }
    // this.getProductTypes();

    // this.getData();
  },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     vm.prevRoute = from;
  //   });
  // },
  watch: {
    filterMain() {
      if (this.$store.state.productPageFilters) {
        if (!this.$store.state.productPageFilters.currentPage) {
          if (this.currentPage > 1) this.currentPage = 1;
        }
      }
      // this.getMaincat();
      this.getSubcat();
      this.getData();
    },
    filterSub() {
      if (this.filterMain) {
        if (this.$store.state.productPageFilters) {
          if (!this.$store.state.productPageFilters.currentPage) {
            if (this.currentPage > 1) this.currentPage = 1;
          }
        }
        // this.getMaincat();
        // this.getSubcat();
        this.getData();
      }
    },
    currentPage() {
      this.getData();
    },
    sellerId() {
      this.getData();
    },
    productType() {
      this.getData();
    },
    productStatus() {
      this.getData();
    },
  },
  methods: {
    winStepper(windowData) {
      if (windowData) {
        if (windowData.getData) this.getData();
        if (windowData.currentPage) {
          this.currentPage = windowData.currentPage;
        }

        // if (windowData.pages) this.pages = windowData.pages;
        this.type = windowData.type;
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/seller/promoted/product/list ",
        headers: {
          token: localStorage.getItem("token"),
        },

        data: {
          mainCategoryId: this.filterMain,
          categoryId: this.filterSub,
          userid: this.sellerId,
          type: this.productType,
          status: this.productStatus,
          limit: 20,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.products = response.data.data;
            this.pages = response.data.totalPages;
            this.appLoading = false;
          } else {
            this.appLoading = false;
            this.showSnackBar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getMaincat() {
      // this.appLoading = true;
      axios({
        url: "/mainCategory/list",
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          // this.appLoading = false;
          this.category = response.data.data;
          this.filterMain = this.category[0]._id;
        })
        .catch((err) => {
          // this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getSubcat() {
      // this.appLoading = true;
      axios({
        url: "/category/list/" + this.filterMain,
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          itemId: this.filterMain,
        },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status) {
            this.subcategory = response.data.data;
            // this.subcategory.unshift({ name: "All", _id: null });
            // for(let i=0;i<response.data.data.length;i++) {

            // this.subcategory.push(response.data.data[i])
            // }
            // this.filterSub = null;
            this.flagg = true;
          }
        })
        .catch((err) => {
          // this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getsellerList() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/sellers/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.sellerList = response.data.data;
              this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    // getProductTypes() {
    //   this.appLoading = true;
    //   axios({
    //     method: "get",
    //     url: "/type/list",
    //   }).then((response) => {
    //     if (response.data.status) {
    //       this.productTypes = response.data.data;
    //       this.appLoading = false;
    //     } else {
    //       this.appLoading = false;
    //     }
    //   });
    // },
    formatDate(item) {
      var dt = new Date(item);
      // var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
  },
};
</script>
<style>
.head {
  font-family: poppinsregular;
  font-size: 14px;
}
.content {
  font-family: poppinsbold;
  font-size: 13px;
}
</style>